module.exports = __webpack_public_path__ + "img/notifications.6047b227.svg";